module.exports = __webpack_public_path__ + "static/media/frame_84.0c31dfc5.jpg";